// extracted by mini-css-extract-plugin
module.exports = {"button-facebook":"index__button-facebook___1ltQc","buttonFacebook":"index__button-facebook___1ltQc","text":"index__text___OzkDu"};